import './ProgressBar-430cdef7.css';

var classes = {"ProgressBarItem":"prc-ProgressBar-ProgressBarItem-stL6O","shimmer":"prc-ProgressBar-shimmer-i1RxN","ProgressBarContainer":"prc-ProgressBar-ProgressBarContainer-E-z8S"};

export { classes as default };
